import React, { useMemo } from "react";
import { Stack, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";

import { MATERIAL_TYPES, MATERIAL_TYPES_DICT } from "../../constants/materials";
import {
  CustomRadioGroup,
  HubHookFormInput,
  HubHookFormSelect,
  HubHookFormSwitch,
} from "../../components";
import { FOUNDRIES } from "../../constants";

const categories = [
  "SAND",
  "SLURRY",
  "CUP",
  "MRO",
  "CASTINGS",
  "RECIPE",
  "RAW MATERIAL",
];

const CreateMaterialForm = ({ defaultValue, isEdit }) => {
  const { watch } = useFormContext();
  const type = watch("type");
  const isMaterial = useMemo(
    () => Number(type) === MATERIAL_TYPES_DICT.MATERIAL,
    [type],
  );

  return (
    <>
      {!isEdit && (
        <CustomRadioGroup
          name="type"
          options={MATERIAL_TYPES}
          defaultValue={MATERIAL_TYPES_DICT.MATERIAL}
        />
      )}
      <Stack gap="15px" width="100%">
        <HubHookFormInput
          name="name"
          label="Name"
          defaultValue={defaultValue}
          required
        />
        {isMaterial ? (
          <Stack gap="25px" direction="row" alignItems="center">
            <HubHookFormSelect
              name="category"
              label="Category"
              options={categories}
              defaultValue={categories[6]}
              required
            />
            <HubHookFormSwitch
              isCheckbox
              name="remelt"
              label="Remelt"
              defaultValue={true}
              labelPlacement="end"
              required
              fullWidth={false}
              formControlProps={{ sx: { width: "100px" } }}
            />
          </Stack>
        ) : (
          <Stack gap="5px" direction="row">
            <HubHookFormSelect
              name="locationId"
              label="Foundry"
              options={FOUNDRIES}
              required
            />
          </Stack>
        )}
        <HubHookFormInput
          name="weight"
          label="Weight"
          defaultValue={1}
          isDecimal
        />

        {isMaterial && (
          <Stack gap="8px">
            <Typography variant="boldCaption">Pricing per Location</Typography>
            <Stack direction="row" gap="10px" flexWrap="wrap">
              {FOUNDRIES.map((loc) => (
                <Stack key={loc.id} sx={{ minWidth: 140, flex: 1 }}>
                  <HubHookFormInput
                    name={`prices.${loc.id}`}
                    label={loc.label}
                    placeholder="0.00"
                    isCurrency
                  />
                </Stack>
              ))}
            </Stack>
          </Stack>
        )}
      </Stack>
    </>
  );
};

export default CreateMaterialForm;
